<script>
  export default {
    components: { },
    data() {
      return {
      }
    },
    methods: {
    },
    computed: {
    },
    mounted() {
      this.$root.tituloDaPagina = 'Página Inicial';
      this.$root.botaoAcaoMostrar = false;
    }
  }
</script>

<template>
  <div>
    <div class="row hidden-print">
      <div class="col-xs-12">
        
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h4><b>Portal da Transparência</b></h4>
          </div>
          
          <div class="ibox-content">
            
            Algum texto de página inicial
            
          </div>
        </div>
        
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/Transparencia.vue